import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("teqtank-qr")
export class TeqtankQr extends LitElement {
    @property() public accessor src = "";
    @property() public accessor value = "";
    @property() public accessor label = "Scan to open";
    @property() public accessor caption = "";
    @property() public accessor logo = "";
    @property({ type: Number }) public accessor size = 220;
    @property({ type: Boolean }) public accessor downloadable = false;
    public static override styles = css`
        :host {
            display: inline-grid;
            gap: 0.6rem;
            justify-items: center;
            text-align: center;
            font-family: Inter, ui-sans-serif, system-ui, sans-serif;
        }
        .frame {
            position: relative;
            display: inline-grid;
            padding: 0.65rem;
            border: 1px solid var(--teqtank-color-border, #ddd7cc);
            border-radius: 1rem;
            background: #fff;
        }
        img.qr {
            display: block;
            max-width: 100%;
            height: auto;
        }
        img.logo {
            position: absolute;
            inset: 50% auto auto 50%;
            width: 18%;
            aspect-ratio: 1;
            padding: 0.25rem;
            border-radius: 0.5rem;
            background: #fff;
            object-fit: contain;
            transform: translate(-50%, -50%);
        }
        .caption {
            max-width: 18rem;
            font-size: 0.82rem;
            color: var(--teqtank-color-text-muted, #68645d);
        }
        button {
            padding: 0.55rem 0.8rem;
            border: 1px solid var(--teqtank-color-border, #ccc);
            border-radius: 999px;
            background: transparent;
            color: inherit;
            font: inherit;
            font-weight: 700;
            cursor: pointer;
        }
    `;
    protected override render() {
        const source = this.source;
        if (!source) return html``;
        return html`<div class="frame" part="frame">
                <img
                    class="qr"
                    part="image"
                    src=${source}
                    width=${this.size}
                    height=${this.size}
                    alt=${this.label}
                />${
                    this.logo
                        ? html`<img class="logo" part="logo" src=${this.logo} alt="" />`
                        : null
                }
            </div>
            <span class="caption" part="caption">${this.caption || this.label}</span>${
                this.downloadable
                    ? html`<button type="button" @click=${this.download}>Download QR</button>`
                    : null
            }`;
    }
    private get source(): string {
        return (
            this.src ||
            (this.value
                ? `https://api.qrserver.com/v1/create-qr-code/?size=${this.size}x${this.size}&data=${encodeURIComponent(this.value)}`
                : "")
        );
    }
    private download(): void {
        const source = this.source;
        if (!source || typeof document === "undefined") return;
        const anchor = document.createElement("a");
        anchor.href = source;
        anchor.download = "teqtank-qr.png";
        anchor.click();
        this.dispatchEvent(
            new CustomEvent("teqtank-qr-downloaded", {
                detail: { value: this.value, src: source },
                bubbles: true,
                composed: true,
            }),
        );
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "teqtank-qr": TeqtankQr;
    }
}
